import toQueryFormat from '../lib/toQueryFormat';

const locales = [
  'cs-CZ',
  'da-DK',
  'de-AT',
  'de-CH',
  'de-DE',
  'en-AU',
  'en-CA',
  'en-GB',
  'en-IE',
  'en-IN',
  'en-NZ',
  'en-US',
  'es-AR',
  'es-CL',
  'es-CO',
  'es-ES',
  'es-MX',
  'es-PE',
  'fi-FI',
  'fr-BE',
  'fr-CH',
  'fr-FR',
  'fr-LU',
  'hu-HU',
  'it-CH',
  'it-IT',
  'ja-JP',
  'nb-NO',
  'nl-BE',
  'nl-NL',
  'pl-PL',
  'pt-BR',
  'pt-PT',
  'ru-RU',
  'sv-SE',
  'tr-TR',
  'zh-CN',
  'zh-HK',
];

const defaultLocale = 'en-US';

const jobUrls = locales.map(locale => toQueryFormat(locale));

export {
  locales,
  defaultLocale,
  jobUrls,
};
